import { render, staticRenderFns } from "./forgetPwd-inner.vue?vue&type=template&id=700f8f97"
import script from "./forgetPwd-inner.vue?vue&type=script&lang=js"
export * from "./forgetPwd-inner.vue?vue&type=script&lang=js"
import style0 from "./forgetPwd-inner.vue?vue&type=style&index=0&id=700f8f97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports